// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"textImageBlock_wrapper__VRmUl"};